<template>
    <v-card>
        <v-card-text>
            <v-flex class="text-xs-center headline primary--text">
                Ao atualizar a página seu smartlock será bloqueado. Quer continuar?
            </v-flex>
            <v-flex class="subheading text-xs-center grey--text text--darken-2 font-weight-medium">
                <v-btn color="primary" @click="atualizarPagina(false)">Não</v-btn>
                <v-btn color="primary" @click="atualizarPagina(true)">Sim</v-btn>
            </v-flex>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
  data () {
    return {
      btn: false
    }
  },
  methods: {
    atualizarPagina (resposta) {
      if (resposta) {
        document.location.reload()
      } else {
        this.$emit('fechar')
      }
    }
  }
}
</script>
